export default "__VITE_ASSET__DXQfuYX2__"